export const adaptProjectCountries = (countryKey, countries) =>
  countries
    .filter((country) => countryKey.includes(country.value))
    .map((item) => item.label)
    .join(", ");
